import React, { useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import api from "../../services/api";
import { toast } from "react-toastify";
import { useUser } from "../../Context/UserProvider";
import { useNavigate } from "react-router-dom";

const TransferFunds = () => {
  const navigate = useNavigate();
  const { user } = useUser();

  const [loading, setLoading] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);

  const [formValues, setFormValues] = useState({
    amount: "",
    currency: "espees",
    recipient: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const Loader = () => (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1300,
      }}
    >
      <CircularProgress size={60} thickness={4.5} />
    </Box>
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    setOpenConfirm(true); // Open confirmation modal
  };

  const handleConfirmSubmit = () => {
    if (user.status === "inactive") {
      toast.error("Please contact admin to activate your account");
      setLoading(false);
      setOpenConfirm(false);
      return;
    }

    setLoading(true);
    setOpenConfirm(false);

    const formData = new FormData();
    formData.append("amount", formValues.amount);
    formData.append("recipient_username", formValues.recipient);
    formData.append("currency", formValues.currency);

    api.payments
      .transferFund(formData)
      .then((res) => {
        toast.success(res.data?.message);
        setFormValues({
          amount: "",
          recipient: "",
          currency: "espees",
        });
        navigate("/dashboard");
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Transfer failed");
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      {loading && <Loader />}
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          maxWidth: 400,
          margin: "0 auto",
          padding: 2,
          boxShadow: 3,
          borderRadius: 1,
          backgroundColor: "white",
        }}
      >
        <Typography variant="h5" component="h2" gutterBottom>
          Transfer Fund
        </Typography>

        <TextField
          label="Recipient Username"
          variant="outlined"
          name="recipient"
          value={formValues.recipient}
          onChange={handleInputChange}
          fullWidth
          required
        />

        <TextField
          label="Amount in ESPEES or Naira"
          type="number"
          variant="outlined"
          name="amount"
          value={formValues.amount}
          onChange={handleInputChange}
          fullWidth
          required
        />

        <FormControl fullWidth>
          <InputLabel id="currency-select">Funds Type</InputLabel>
          <Select
            labelId="currency-select"
            id="currency"
            name="currency"
            value={formValues.currency}
            label="Funds Type"
            onChange={handleInputChange}
          >
            <MenuItem value={"espees"}>ESPEES</MenuItem>
            <MenuItem value={"naira"}>Naira</MenuItem>
          </Select>
        </FormControl>

        <Button type="submit" variant="contained" color="primary">
          Submit
        </Button>
      </Box>

      {/* Confirmation Dialog */}
      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>Confirm Transfer</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to transfer{" "}
            <strong>{formValues.amount}</strong> {formValues.currency.toUpperCase()} to{" "}
            <strong>{formValues.recipient}</strong>?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)} color="secondary">
            No
          </Button>
          <Button onClick={handleConfirmSubmit} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TransferFunds;
